module.exports = __webpack_public_path__ + "static/media/11.89d506c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/11.jpg
// module id = 574
// module chunks = 0